import { FC } from 'react';

import { Slideout, SlideoutCommonProps } from 'components/design-system/Slideout';
import { COLORS } from 'consts';
import styles from 'styles/Auctions.module.scss';
import { Listing, ProxyBid } from 'types';
import { formatPrice } from 'utils/text-helpers';

import { useOnPlaceBid } from '../hooks';

export const OutbidModalTestIds = {
  container: 'outbid-modal-container',
  icon: 'outbid-modal-icon'
};

export type OutbidModalProps = {
  listing: Listing;
  closeModal: () => void;
  proxyBid?: ProxyBid;
} & SlideoutCommonProps;

export const OutbidModal: FC<OutbidModalProps> = ({ isOpen, closeModal, listing, proxyBid }) => {
  const onPlaceBidModal = useOnPlaceBid(listing, undefined, proxyBid);

  return (
    <Slideout
      isDark
      data-testid={OutbidModalTestIds.container}
      title='You’ve been outbid'
      isOpen={isOpen}
      closeModal={closeModal}
      className={styles.modal}
      submit={{
        title: (
          <span style={{ color: COLORS.darkRed2 }} className='fs-16px riforma-medium'>
            Increase your bid
          </span>
        ),
        onClick: onPlaceBidModal,
        variant: 'pink'
      }}
    >
      <div className='riforma-regular text-center h-100 text-light d-flex flex-column justify-content-around align-items-center'>
        <div>
          <div className='w-100 py-3 border-radius-16' style={{ backgroundColor: COLORS.pink08 }}>
            <div className='opacity-60 pb-2 fs-12px'>CURRENT BID</div>
            <div className='fs-20px text-pink'>{formatPrice(listing.auctionInfo.highestBid.priceCents)}</div>
          </div>
          <div className='opacity-60 line-height-24px mb-5 mt-4 px-4'>
            You’ll need to place a new max bid that is higher than the current bid to reclaim the highest bid position
          </div>
        </div>
      </div>
    </Slideout>
  );
};
